export const SUPPORTED_FILE_SIZE = 1024 * 1024 * 1024 // 1GB

// backend/src/datasources/kpiImportService.ts の上限値と同値にする
export const KPI_IMPORT_MAX_UPLOAD_BYTES = 10 * 1024 * 1024

// batch/src/utils/constants.ts の DURATION_SECONDS_LIMIT と同値にする。
// これ未満の録音は batch が評価せずアーカイブするため、アップロード前に止める
export const MIN_ASSESSMENT_DURATION_SECONDS = 90

export const SUPPORTED_TEXT_EXTENSIONS = ['txt', 'json']

// backend/src/utils/audioFile.ts の AUDIO_EXTENSIONS と同値にする。
// 表示判定と手動アップロード受付の両方に使う
export const SUPPORTED_AUDIO_EXTENSIONS = [
  'mp3',
  'mp4',
  'aac',
  'wav',
  'm4a',
  'webm',
]
